import React from "react";

type ViewOption = {
  label: string; // Display text for the button
  value: string; // Value to set for screen
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

type ViewSwitcherProps = {
  screen: string;
  setScreen: (screen: string) => void;
  options: ViewOption[];
};

function ViewSwitcher({ screen, setScreen, options }: ViewSwitcherProps) {
  const getButtonClass = (isActive: boolean) =>
    `px-3 py-2 rounded-md font-bold ${
      isActive ? "bg-white text-[#2B4752]" : "bg-[#E1E3E3] text-[#7C7D7D]"
    }`;
  return (
    <div className="flex items-center gap-2">
      {options.map((option) => {
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            data-testid={`view-switcher-${option.value}`}
            className={getButtonClass(screen === option.value)}
            onClick={() => setScreen(option.value)}
          >
            <span className="flex items-center gap-1">
              {option.label}
              {Icon ? <Icon /> : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default ViewSwitcher;
